<template>
  <div>
    <template v-if="dataSource.data && dataSource.data.length >0">
      <a-collapse expand-icon-position="right">
        <a-collapse-panel
          key="chainalysis-data"
          :header="'chainalysis-report.lbl-report' | globalize">
          <a-list
            item-layout="horizontal"
            :data-source="dataSource.data"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item">
              <a-list-item-meta
                :description="item.description"
              >
                <a
                  slot="title"
                  :href="item.url">
                  {{ item.name }}
                </a>

                <div slot="avatar">
                  {{ item.category }}
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
    </template>
    <template v-else>
      {{ 'chainalysis-report.lbl-no-sanctions' | globalize }}
    </template>
  </div>
</template>

<script>
import ACollapse from 'ant-design-vue/lib/collapse/Collapse'
import ACollapsePanel from 'ant-design-vue/lib/collapse/CollapsePanel'
import AList from 'ant-design-vue/lib/list'

export default {
  name: 'chainalysis-risk-report',
  components: {
    'a-collapse': ACollapse,
    'a-collapse-panel': ACollapsePanel,
    'a-list': AList,
    'a-list-item': AList.Item,
    'a-list-item-meta': AList.Item.Meta,
  },
  props: {
    dataSource: {
      type: Object,
      // required: true,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~ant-design-vue/lib/list/style/index.css';
  @import '~ant-design-vue/lib/collapse/style/index.css';
</style>
